import { message } from "antd";
import {
  ADMIN_ADD_COURSE_REQUEST,
  ADMIN_ADD_COURSE_SUCCESS,
  ADMIN_ADD_COURSE_FAIL,
  ADMIN_GET_COURSE_REQUEST,
  ADMIN_GET_COURSE_SUCCESS,
  ADMIN_GET_COURSE_FAIL,
  ADMIN_UPDATE_COURSE_REQUEST,
  ADMIN_UPDATE_COURSE_SUCCESS,
  ADMIN_UPDATE_COURSE_FAIL,
  ADMIN_DELETE_COURSE_REQUEST,
  ADMIN_DELETE_COURSE_SUCCESS,
  ADMIN_DELETE_COURSE_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/courseConstants";
import axios from "../../../axiosInstance";

// Add Course
export const addCourse = (courseData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_ADD_COURSE_REQUEST });

    const { data } = await axios.post(
      "/api/v1/course/admin-add-course",
      courseData
    );

    dispatch({
      type: ADMIN_ADD_COURSE_SUCCESS,
      payload: data,
    });
    if (data?.success === true) {
      dispatch({ type: ADMIN_ADD_COURSE_SUCCESS, payload: data });
      message.success(
        data?.message || "Course details Added successfully"
      );
    } else {
      throw new Error(data?.message || "Failed to Added course details");
    }
  } catch (error) {
    dispatch({
      type: ADMIN_ADD_COURSE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    message.error(
      error?.response?.data?.message || "Failed to Added course details"
    );
  }
};

// Get Courses
export const getCourses = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_GET_COURSE_REQUEST });

    const { data } = await axios.get("/api/v1/course/admin-get-course");

    dispatch({
      type: ADMIN_GET_COURSE_SUCCESS,
      payload: data.courses,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_GET_COURSE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update Course
export const updateCourse = (id, courseData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_UPDATE_COURSE_REQUEST });

    const { data } = await axios.put(`/api/v1/course/admin-update-course`, {
      id,
      courseData,
    });
    if (data?.success === true) {
      dispatch({ type: ADMIN_UPDATE_COURSE_SUCCESS, payload: data });
      message.success(data?.message || "Course details updated successfully");
    } else {
      throw new Error(data?.message || "Failed to updated course");
    }
  } catch (error) {
    dispatch({
      type: ADMIN_UPDATE_COURSE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    message.error(error?.response?.data?.message || "Failed to update course");
  }
};

// Delete Course
export const deleteCourse = (id) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_DELETE_COURSE_REQUEST });

    const response = await axios.delete(`/api/v1/course/admin-delete-course`, {
      data: { id },
    });
    if (response?.data?.success === true) {
      dispatch({ type: ADMIN_DELETE_COURSE_SUCCESS, payload: id });
      message.success(response?.data?.message || "Course deleted successfully");
    } else {
      throw new Error(response?.data?.message || "Failed to delete course");
    }
  } catch (error) {
    dispatch({
      type: ADMIN_DELETE_COURSE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    message.error(error?.response?.data?.message || "Failed to delete course");
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
